/**
 * B Shop - captura de email en el carrito (cart drawer y pagina de carrito).
 * Funciona con el bloque snippets/bshop-cart-email.liquid. No bloquea la compra.
 *
 * - Crea el cliente con el formulario nativo de Shopify (suscripto a email marketing, etiquetas
 *   newsletter, popup-15 y carrito-guardado).
 * - Guarda el email en el atributo del carrito "bshop_email".
 * - "Seguir sin email" oculta el bloque durante 7 dias.
 * - Eventos GA4 sin datos personales: cart_email_submit, cart_email_success, generate_lead,
 *   cart_email_skip y cart_email_error.
 *
 * Usa delegacion de eventos en document: el drawer se vuelve a dibujar (morph) cada vez que cambia el
 * carrito, asi que no se puede enganchar el formulario una sola vez.
 */
(function () {
  if (window.__bshopCartEmailBound) return;
  window.__bshopCartEmailBound = true;

  var DISMISS_KEY = 'bshop_cart_email_dismissed_at';
  var WELCOME_KEY = 'bshop_welcome_subscribed';
  var DISMISS_MS = 7 * 86400000;
  var MESSAGES = {
    invalid: 'Ingresá un email válido, por ejemplo nombre@gmail.com.',
    server: 'No pudimos guardar tu email. Probá de nuevo en unos minutos.',
    network: 'Parece que no hay conexión. Revisá tu internet y probá de nuevo.'
  };
  var root = document.documentElement;

  function get(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function set(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  // GA4: solo nombres de evento y parametros genericos, nunca el email.
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    } catch (e) {}
  }

  function isEmail(value) {
    var at = value.indexOf('@');
    var dot = value.lastIndexOf('.');
    return (
      at > 0 &&
      at === value.lastIndexOf('@') &&
      dot > at + 1 &&
      value.length - dot > 2 &&
      value.indexOf(' ') === -1 &&
      value.length <= 254
    );
  }

  // Oculta el bloque si lo descartaron hace menos de 7 dias o si ya dejaron el email en el pop-up.
  function syncHidden() {
    var dismissedAt = Number(get(DISMISS_KEY) || 0);
    var hidden = (dismissedAt && Date.now() - dismissedAt < DISMISS_MS) || get(WELCOME_KEY) === '1';
    if (hidden) root.setAttribute('data-bshop-cart-email-hidden', '');
    else root.removeAttribute('data-bshop-cart-email-hidden');
  }
  syncHidden();

  function setLoading(form, on) {
    var button = form.querySelector('.bshop-cart-email__submit');
    form.setAttribute('aria-busy', on ? 'true' : 'false');
    if (button) {
      button.disabled = on;
      button.classList.toggle('is-loading', on);
    }
  }

  function showError(box, text, type) {
    var out = box.querySelector('.bshop-cart-email__error');
    var input = box.querySelector('.bshop-cart-email__input');
    if (out) out.textContent = text;
    if (input) input.setAttribute('aria-invalid', 'true');
    track('cart_email_error', { error_type: type });
  }

  function clearError(box) {
    var out = box.querySelector('.bshop-cart-email__error');
    var input = box.querySelector('.bshop-cart-email__input');
    if (out) out.textContent = '';
    if (input) input.removeAttribute('aria-invalid');
  }

  // Guarda el email en el carrito: queda en el pedido y en el checkout abandonado.
  function saveCartEmail(email) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { bshop_email: email } })
    }).catch(function () {});
  }

  function showSuccess(box) {
    var text = box.getAttribute('data-success-text') || '';
    box.classList.add('bshop-cart-email--saved');
    while (box.firstChild) box.removeChild(box.firstChild);
    var check = document.createElement('span');
    check.className = 'bshop-cart-email__check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    var message = document.createElement('p');
    message.className = 'bshop-cart-email__saved-text';
    message.setAttribute('role', 'status');
    message.textContent = text;
    box.appendChild(check);
    box.appendChild(message);
    track('cart_email_success');
    track('generate_lead', { lead_source: 'cart_email' });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('bshop-cart-email__form')) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;

    var box = form.closest('.bshop-cart-email');
    var input = form.querySelector('.bshop-cart-email__input');
    var email = input ? input.value.trim() : '';
    if (input) input.value = email;
    if (!box) return;

    if (!isEmail(email)) {
      showError(box, MESSAGES.invalid, 'invalid');
      if (input) input.focus();
      return;
    }

    clearError(box);
    setLoading(form, true);
    track('cart_email_submit');

    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        // Shopify pide un desafio anti-bots: se completa con el envio normal del formulario.
        if (response.url.indexOf('/challenge') !== -1) {
          return saveCartEmail(email).then(function () {
            HTMLFormElement.prototype.submit.call(form);
            return null;
          });
        }
        return response.text().then(function (html) {
          return { response: response, html: html };
        });
      })
      .then(function (result) {
        if (!result) return;
        if (result.response.url.indexOf('customer_posted=true') !== -1 && result.response.ok) {
          return saveCartEmail(email).then(function () {
            showSuccess(box);
          });
        }
        var doc = new DOMParser().parseFromString(result.html, 'text/html');
        var serverError = doc.querySelector('.bshop-cart-email [data-state="error"]');
        showError(box, (serverError && serverError.textContent.trim()) || MESSAGES.server, 'server');
      })
      .catch(function () {
        showError(box, MESSAGES.network, 'network');
      })
      .then(function () {
        if (!box.classList.contains('bshop-cart-email--saved')) setLoading(form, false);
      });
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var skip = target.closest('[data-bshop-cart-email-skip]');
    if (!skip) return;
    set(DISMISS_KEY, String(Date.now()));
    syncHidden();
    track('cart_email_skip');
  });
})();
